import {
  Brain,
  Layers,
  Repeat,
  Compass,
  Sparkles,
  Users,
  Flame,
} from "lucide-react";

const ITEMS = [
  {
    icon: Brain,
    text: "You want to start a business but keep overthinking.",
  },
  {
    icon: Layers,
    text: "You already have a business but need structure.",
  },
  {
    icon: Repeat,
    text: "You struggle with consistency.",
  },
  {
    icon: Compass,
    text: "You want accountability and direction.",
  },
  {
    icon: Sparkles,
    text: "You want to build your personal brand.",
  },
  {
    icon: Users,
    text: "You want to surround yourself with ambitious people.",
  },
  {
    icon: Flame,
    text: "You're serious about changing your life through business.",
  },
];

export const WhoFor = () => {
  return (
    <section
      id="who-for"
      data-testid="who-for-section"
      className="relative bg-[#050505] py-24 md:py-40 border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16 md:mb-20">
          <div className="reveal flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-zinc-600" />
            <span className="text-xs tracking-[0.3em] uppercase text-zinc-400 font-bold">
              The Fit
            </span>
          </div>
          <h2
            data-testid="who-for-headline"
            className="reveal text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-extrabold text-white leading-[1.02]"
          >
            This is for you{" "}
            <span className="italic font-light text-zinc-300">if…</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-zinc-900 border border-zinc-900">
          {ITEMS.map((item, i) => {
            const Icon = item.icon;
            const isLast = i === ITEMS.length - 1;
            return (
              <div
                key={i}
                data-testid={`who-for-card-${i + 1}`}
                className={`reveal group bg-[#0A0A0A] hover:bg-[#0F0F0F] transition-colors duration-500 p-8 md:p-10 ${
                  isLast ? "md:col-span-2 lg:col-span-3" : ""
                }`}
              >
                <div className="flex items-center justify-between mb-8">
                  <Icon
                    className="w-6 h-6 text-zinc-400 group-hover:text-white transition-colors duration-300"
                    strokeWidth={1.4}
                  />
                  <span className="text-xs tracking-[0.25em] uppercase text-zinc-700 font-bold">
                    0{i + 1}
                  </span>
                </div>
                <p className="text-lg md:text-xl leading-snug text-white font-semibold tracking-tight">
                  {item.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
